export default "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYzFmYmYwZWZjOWNiMzNlNTQ0NDgxMzExNzg2Yjc4MjcuanBnIjs="